// extracted by css-extract-rspack-plugin
export default {"table":"C0XtT","cell":"JDynk","headerCell":"aAl0C","row":"fJZfM","entityNameLink":"PIA6O"};